import { BET_OPTIONS, BettingState, PlaceResult } from "@ppb/betslip-core";

export const legHasBonusBall = (leg: BettingState.Leg | PlaceResult.PlacedLeg | undefined): boolean =>
  leg?.appliedOptions?.some((opt) => opt.optionType === BET_OPTIONS.BONUS_BALL) ?? false;
